module.exports = __webpack_public_path__ + "static/media/linkedin.03c7255a.svg";